import React, { useState } from 'react';
import {
  Card, Col, FormCheck, Row,
} from 'react-bootstrap';
import '../alert-form.css';
import { useDispatch, useSelector } from 'react-redux';
import readingType from '@avtechsoftware/ra-javascript-utilities/src/types/ReadingType';
import NewSharedThresholdModal from './NewSharedThresholdModal';
import {
  AlertFormSteps,
  selectIsEditingAlertForm,
  selectSensorsData,
  selectThresholdData,
  updateStepData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import AlertFormSharedThresholdSelector from './AlertFormSharedThresholdSelector';
import NewIndependentThresholdForm from './NewIndependentThresholdForm';

function DefineThresholdsForm() {
  const dispatch = useDispatch();
  const [injectStateIntoThresholdModal, setInjectStateIntoThresholdModal] = useState(false);
  const [showNewThresholdModal, setShowNewThresholdModal] = useState(false);
  const thresholdFormData = useSelector(selectThresholdData);
  const selectedSensorsData = useSelector(selectSensorsData);
  const isEdit = useSelector(selectIsEditingAlertForm);
  const { useSharedThreshold } = thresholdFormData;
  const [originalSharedThresholdState] = useState(useSharedThreshold);

  const updateThresholdTypeSelection = (value) => {
    dispatch(updateStepData(
      {
        step: AlertFormSteps.DEFINE_THRESHOLD,
        data: {
          useSharedThreshold: value,
          thresholdId: -1,
        },
      },
    ));
  };
  const isMultipleSensors = selectedSensorsData.selectedChannels.length > 1;

  const thresholdModalInjectionProps = injectStateIntoThresholdModal ? {
    initialReadingType: selectedSensorsData && selectedSensorsData.readingType,
    initialOperatorId: thresholdFormData && thresholdFormData.thresholdOperator,
    initialValue: thresholdFormData && thresholdFormData.thresholdValue,
  } : {
    initialReadingType: selectedSensorsData && selectedSensorsData.readingType,
  };
  return (
    <Card className="alert-card">
      <Card.Body>
        <Row>
          <Col>
            <h6 className="alert-form-section-label">Next, define your threshold.</h6>
          </Col>
        </Row>
        <Row className="mb-4 mt-2">
          <Col className="ml-2">
            <FormCheck
              type="radio"
              id="threshold-type-independent"
              label={(
                <>
                  <span style={{ fontWeight: 500 }}>Independent</span>
                  {' '}
                  -
                  {' '}
                  {isMultipleSensors
                    ? 'Specify a threshold for your selected sensors. This will generate multiple alerts, each with an identical threshold that can be edited individually.'
                    : 'Specify a threshold for your selected sensor that will only be used in this alert.'}
                </>
              )}
              name="thresholdType"
              checked={!useSharedThreshold}
              onChange={() => updateThresholdTypeSelection(false)}
              className="mb-0"
            />
            <NewIndependentThresholdForm
              disabled={useSharedThreshold}
              cloneToSharedEnabled={originalSharedThresholdState === false && isEdit}
              cloneIndependentToShared={() => {
                setInjectStateIntoThresholdModal(true);
                setShowNewThresholdModal(true);
              }}
            />

            <FormCheck
              type="radio"
              id="threshold-type-shared"
              disabled={selectedSensorsData.readingType <= 0
                  || selectedSensorsData.readingType === readingType.GENERIC_BOOLEAN.id}
              label={(
                <>
                  <span style={{ fontWeight: 500 }}>Shared</span>
                  {' '}
                  -
                  {' '}
                  Select or create a reusable threshold that can be applied to
                  multiple
                  alerts and graphs. Editing it later will update all alerts
                  associated with it.
                </>
              )}
              name="thresholdType"
              checked={useSharedThreshold}
              onChange={() => updateThresholdTypeSelection(true)}
              className="mb-1 mt-2"
            />
            <AlertFormSharedThresholdSelector
              disabled={!useSharedThreshold}
              onCreateNew={() => setShowNewThresholdModal(true)}
            />
          </Col>
        </Row>
      </Card.Body>
      {showNewThresholdModal && (
        <NewSharedThresholdModal
          onClose={() => setShowNewThresholdModal(false)}
          {...thresholdModalInjectionProps}
        />
      )}

    </Card>
  );
}

export default DefineThresholdsForm;
